import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Prefer sessionStorage (impersonation tab) over localStorage (main tab)
export function getToken() {
  try {
    return sessionStorage.getItem("zm_token") || localStorage.getItem("zm_token");
  } catch { return null; }
}

export function setToken(token, { session = false } = {}) {
  try {
    if (session) sessionStorage.setItem("zm_token", token);
    else localStorage.setItem("zm_token", token);
  } catch { /* ignore */ }
}

export function clearToken() {
  try {
    // Clear whichever storage has it
    if (sessionStorage.getItem("zm_token")) sessionStorage.removeItem("zm_token");
    else localStorage.removeItem("zm_token");
  } catch { /* ignore */ }
}

export function isImpersonating() {
  try { return !!sessionStorage.getItem("zm_token"); } catch { return false; }
}

const api = axios.create({
  baseURL: API,
  // No cookies when impersonating (they'd override with master's session)
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Erro inesperado";
}
